import React, { useState, useEffect, useContext } from 'react';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';
import './FacilityUserUnitView.css';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import baseApi from '../../common/api/base';
import NotesHistory from '../NotesHistory/NotesHistory';
import PowerBiReport from '../PowerBiReport/PowerBiReport';
import UnitSummary from '../UnitSummary/UnitSummary';
import logComponent from '../../common/logComponent';

export default function FacilityUserUnitView({ match }) {
  const environmentContext = useContext(EnvironmentContext);
  const [loadingSelectedUnit, setLoadingSelectedUnit] = useState(false);
  const navigate = useNavigate();
  const { selectedUnit, setSelectedUnit } = environmentContext;
  const { unitId } = useParams();

  if (logComponent('FacilityUserUnitView')) { console.debug('FacilityUserUnitView rendered'); }


  useEffect(() => {
    if (logComponent('FacilityUserUnitView')) { console.debug('FacilityUserUnitView useEffect [environmentContext.selectedUnit, loadingSelectedUnit, match.params.unitId]'); }
    if (!loadingSelectedUnit && (!selectedUnit || selectedUnit.unitId != unitId)) {
      loadRoutedUnit();
    }
  }, [environmentContext.selectedUnit, loadingSelectedUnit, unitId]);

  const loadRoutedUnit = () => {
    if (logComponent('FacilityUserUnitView')) { console.debug('FacilityUserUnitView loadRoutedUnit'); }
    const { hasToken } = environmentContext;
    if (!hasToken) return;


    // Check for obviously bad params to avoid unnecessary api calls
    if (isNaN(unitId)) {
      navigate('/', { replace: true });
      return;
    }

    //baseApi.Unit.Id(params.unitId, true)
    baseApi.Unit.Id(unitId, true)
      .then(
        result => {
          setSelectedUnit(result.data);
        },
        error => {
          navigate('/', { replace: true });
        });
  }

  return (
    selectedUnit ?
      <div className="Facility-User-Monitored-Individual-View">
        <Routes>
          <Route path='/*' element={<UnitSummary />} />
          <Route path='/notes/*' element={<NotesHistory />} />
          <Route path='/reports/:reportId' element={<PowerBiReport />} />
        </Routes>
      </div> :
      null
  );
}